import React from 'react';
import Joi from 'joi-browser';
import * as _ from 'lodash';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { GroupSettingService } from '../services/GroupSetting';
import { GroupSettingContents } from '../components/tables/GroupSetting';
import { TouchDeviceInvisible } from '../components/TouchDeviceInvisible';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import _slideLoader from '../utilities/slideLoader';
import SessionStorageService from '../services/utilities/SessionStorageService';
import EventMg from '../utilities/EventManager';

const MY_EVENT = {
  LOAD_SETTING_GROUP: 'load_setting_group', // 一覧取得
};

/**
 * グループ設定
 *
 * @export
 * @class GroupSetting
 * @extends {React.Component}
 */
export class GroupSetting extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getItem('field_id'),
      total: 0,
      loaded: false,
      groupSettings: [],
      canDrop: false, // ドラッグアンドドロップの状態
      searched: false, // 検索の状態
      dragSort: [], // ドラッグアンドドロップの並び順の仮置き場
      orderParam: {
        order: 'order_number_asc',
      },
      isOpened: false,
      isSettingId: null,
      errors: {},
      isLoading: true, // ロード中フラグ
    };

    this.events = {
      // 新規作成
      createGroupSetting: this.createGroupSetting.bind(this),
      table: {
        edit: this.editGroupSetting.bind(this),
      },
      // ドラッグアンドドロップ用メソッド
      dnd: {
        onHover: this.onHover.bind(this),
        onBeginDrag: this.onBeginDrag.bind(this),
        onDropped: this.onDropped.bind(this),
        draggable: this.draggable.bind(this),
        orderSubmit: this.eventOrderSubmit.bind(this),
      },
    };

    this.schema = Joi.object().keys({
      id: Joi.allow(),
      display_flag: Joi.number().required(),
      name: Joi.string()
        .max(255)
        .required(),
      kana: Joi.string()
        .max(255)
        .required(),
    });

    // 一覧取得イベント登録(編集や削除して戻った時のロードのため)
    EventMg.registerEvent(MY_EVENT.LOAD_SETTING_GROUP);
    EventMg.addEventListener(MY_EVENT.LOAD_SETTING_GROUP, () => {
      this.setGroupSetting();
    });
  }

  componentDidMount() {
    this.setGroupSetting(this.state.orderParam);
  }

  /**
   * 一覧の設定
   *
   * @param {*} orderParam
   * @param {*} notify
   * @returns
   * @memberof GroupSetting
   */
  setGroupSetting(orderParam, notify) {
    if (this.state.loaded && notify) {
      notify();
      this.setState({ isLoading: false });
      return;
    }
    const pageParam = {
      offset: notify ? _.size(this.state.groupSettings) : 0,
    };

    const fieldId = this.state.fieldId;
    const groupSettingParams = _.assign(orderParam, pageParam);
    GroupSettingService.list(fieldId, groupSettingParams).then(resp => {
      if (resp.result) {
        const getGroupSetting = resp.data.entities.field_groups;
        if (_.isEmpty(getGroupSetting) && notify) {
          this.setState({
            loaded: true,
          });
        } else {
          let groupSettings = notify ? this.state.groupSettings : [];
          _.each(getGroupSetting, groupSetting => {
            groupSettings.push(groupSetting);
          });
          this.setState({
            groupSettings: _.cloneDeep(groupSettings),
            total: resp.data.total,
            loaded: false,
          });
        }
      }
      this.setState({ isLoading: false });
      if (notify) {
        notify();
        return;
      }
    });
  }

  handleSearchFormShow = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * 新規作成
   *
   * @memberof GroupSetting
   */
  createGroupSetting = () => {
    let craneData = {
      state: {},
    };
    _slideLoader.show('GroupSettingNew', craneData, this.props.vw);
  };

  /**
   * 編集
   *
   * @memberof GroupSetting
   */
  editGroupSetting(crane) {
    let craneData = {
      state: {
        id: crane.id,
      },
    };
    _slideLoader.show('GroupSettingEdit', craneData, this.props.vw);
  }

  /* eslint-disable no-unused-vars */
  /**
   * ホバー
   */
  onHover(props, monitor, component) {}

  /**
   * ドラッグ開始
   */
  onBeginDrag(props, monitor, component) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[0] = props.index;
    this.setState({ dragSort });
  }

  /**
   * ドロップダウン
   */
  onDropped(dragProps, dropProps, monitor, dropComponent) {
    let dragSort = _.cloneDeep(this.state.dragSort);
    dragSort[1] = dropProps.index;
    this.setState({ dragSort });
    this.sortList(...this.state.dragSort);
  }

  /**
   * ドラッグ開始、終了
   */
  draggable(bool) {
    this.setState({ canDrag: bool });
  }

  /**
   * @description 並び順を変更する
   */
  sortList(dragIndex, to_index) {
    const lists = _.cloneDeep(this.state.groupSettings);
    const formItem = lists[dragIndex];
    if (to_index < dragIndex) {
      lists.splice(to_index, 0, formItem);
      lists.splice(dragIndex + 1, 1);
    } else {
      lists.splice(to_index + 1, 0, formItem);
      lists.splice(dragIndex, 1);
    }
    this.setState({ groupSettings: lists });
  }

  /**
   * 並び替えの決定
   *
   * @memberof GroupSetting
   */
  eventOrderSubmit = () => {
    const fieldId = this.state.fieldId;
    const items = this.state.groupSettings;
    const params = { ids: _.map(items, 'id') };
    GroupSettingService.updateOrder(fieldId, params).then(resp => {
      if (resp.result) {
        this.setGroupSetting(this.state.orderParam);
      }
    });
  };

  /**
   * ヘッダのメニュー
   *
   * @memberof GroupSetting
   */
  headerMenu = () => {
    if (this.state.canDrag) {
      return (
        <div className='setting-header__item'>
          <button
            className='btn--effective'
            onClick={() => {
              this.events.dnd.orderSubmit();
              this.events.dnd.draggable(false);
            }}
          >
            保存
          </button>
        </div>
      );
    }
    return (
      <div className='setting-header__item'>
        <button
          className='btn'
          onClick={() => this.events.createGroupSetting()}
          style={{
            display: !_.isNull(this.state.isSettingId)
              ? 'none'
              : 'inline-block',
          }}
        >
          新規作成
        </button>
        <TouchDeviceInvisible>
          <button
            className='btn--sub'
            onClick={() => this.events.dnd.draggable(true)}
            style={{
              display:
                this.state.searched || this.state.isSettingId !== null
                  ? 'none'
                  : 'inline-block',
            }}
          >
            並び順を変更する
          </button>
        </TouchDeviceInvisible>
      </div>
    );
  };

  render() {
    return (
      <div id='infinityscroll-target' className='setting-main__body'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - グループ設定</title>
        </Helmet>

        <div id='setting-header' className='setting-header'>
          {this.headerMenu()}
        </div>
        <GroupSettingContents
          groupSettings={this.state.groupSettings}
          callbacks={this.events}
          canDrag={this.state.canDrag}
          infinityScrollLoad={
            <InfinityScrollLoad
              targetId='infinityscroll-target'
              total={_.size(this.state.groupSettings)}
              isLoading={this.state.isLoading}
              callback={notifyEnd => {
                this.setGroupSetting(this.state.orderParam, notifyEnd);
              }}
            />
          }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/GroupSetting.jsx